"use strict";

exports.__esModule = true;
exports.AsyncLoader = void 0;
var _react = require("react");
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Loads data via an async `load` prop, provides a render prop with
 * access to the result and state of the promise.
 */
var AsyncLoader = exports.AsyncLoader = /*#__PURE__*/function (_Component) {
  function AsyncLoader() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.hasMounted = false;
    _this.state = {
      loaded: false,
      fetching: true,
      reload: function reload() {
        return _this.runLoader(_this.props);
      },
      data: undefined,
      error: undefined,
      update: function update(setter) {
        if (_this.hasMounted) {
          _this.setState(function (_ref) {
            var data = _ref.data;
            return {
              data: setter(data)
            };
          });
        }
      }
    };
    return _this;
  }
  _inheritsLoose(AsyncLoader, _Component);
  var _proto = AsyncLoader.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    this.hasMounted = true;
    if (this.props.setReload) {
      this.props.setReload(function () {
        return _this2.runLoader(_this2.props);
      });
    }
    this.runLoader(this.props);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.hasMounted = false;
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this3 = this;
    if (!(0, _reactFastCompare["default"])(this.props.params, prevProps.params)) {
      if (this.props.setReload) {
        this.props.setReload(function () {
          return _this3.runLoader(_this3.props);
        });
      }
      this.runLoader(this.props);
    }
  };
  _proto.runLoader = function runLoader(_ref2) {
    var _this4 = this;
    var load = _ref2.load,
      params = _ref2.params;
    var onData = this.props.onData;
    if (!this.hasMounted) {
      return;
    }
    var result = load(params);
    if (result != null && typeof result.then === "function") {
      if (!this.state.fetching) {
        this.setState({
          fetching: true
        });
      }
      Promise.resolve(result).then(function (data) {
        _this4.hasMounted && _this4.setState({
          loaded: true,
          fetching: false,
          data: data,
          error: undefined
        });
        if (onData) {
          onData(data);
        }
      }, function (error) {
        return _this4.hasMounted && _this4.setState({
          fetching: false,
          error: error
        });
      });
    } else {
      this.setState({
        fetching: false,
        data: result
      });
    }
  };
  _proto.render = function render() {
    return this.props.children(this.state);
  };
  return AsyncLoader;
}(_react.Component);
AsyncLoader.defaultProps = {};